"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CarouselWithCard;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const index_1 = require("../../index");
const Card_1 = __importDefault(require("./Card"));
const useStyles = (0, core_1.makeStyles)(() => ({
    carouselWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },
    carouselContainer: {
        overflow: 'hidden',
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        gap: '25px',
        margin: '0px 50px',
    },
    singleCard: {
        gridTemplateColumns: 'auto',
    },
    carouselButtonPrev: {
        position: 'absolute',
        top: '50%',
        left: '0%',
        border: index_1.StyleVariables.colors.base.white,
        background: 'none',
    },
    carouselButtonNext: {
        position: 'absolute',
        top: '50%',
        right: '0%',
        border: index_1.StyleVariables.colors.base.white,
        background: 'none',
    },
}));
function CarouselWithCard({ cards, itemsToDisplay = 2, }) {
    const classes = useStyles();
    const length = cards.length;
    const [maxItem, setMaxItem] = (0, react_1.useState)(itemsToDisplay);
    const maxLength = length < maxItem ? length : maxItem;
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            if (window.innerWidth < 900) {
                setMaxItem(1);
            }
            else {
                setMaxItem(2);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const updateIndex = (newIndex) => {
        if (newIndex < 0) {
            newIndex = length - 1;
        }
        if (newIndex >= length) {
            newIndex = 0;
        }
        setActiveIndex(newIndex);
    };
    const generateCards = () => {
        const displayCards = [];
        for (let i = activeIndex; i < activeIndex + maxLength; i++) {
            let displayIndex = i;
            if (i >= length) {
                displayIndex = i % length;
            }
            displayCards.push(react_1.default.createElement(Card_1.default, { image: cards[displayIndex].image, title: cards[displayIndex].title, description: cards[displayIndex].description, name: cards[displayIndex].name, designation: cards[displayIndex].designation, key: displayIndex }));
        }
        return displayCards;
    };
    return (react_1.default.createElement("div", { className: classes.carouselWrap },
        react_1.default.createElement("button", { className: classes.carouselButtonPrev, onClick: () => {
                updateIndex(activeIndex - 1);
            } },
            react_1.default.createElement(index_1.OutlinedIcon, { icon: 'arrow_back_ios' })),
        react_1.default.createElement("button", { className: classes.carouselButtonNext, onClick: () => {
                updateIndex(activeIndex + 1);
            } },
            react_1.default.createElement(index_1.OutlinedIcon, { icon: 'arrow_forward_ios' })),
        react_1.default.createElement("div", { className: `${classes.carouselContainer} ${maxItem === 1 ? classes.singleCard : ''}` }, generateCards())));
}
